/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { AsyncPipe } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MatTableModule } from "@angular/material/table";
import { Team, TeamColumn } from "../../../concept/team";
import { MatSortModule } from "@angular/material/sort";
import { ResourceTable, ResourceTableService } from "../../../service/resource-table.service";
import { DatetimePipe, SpinnerComponent } from "typedb-cloud-framework";
import { TableSelectionCellComponent, TableSelectionHeaderCellComponent } from "../../../framework/table";
import { AccessLevelPipe } from "../../../framework/access-level.pipe";

@Component({
    selector: "tp-teams-table",
    templateUrl: "./teams-table.component.html",
    imports: [
        AsyncPipe, DatetimePipe, MatTableModule, MatSortModule,
        SpinnerComponent, AccessLevelPipe,
    ]
})
export class TeamsTableComponent {
    @Input({ required: true}) table!: ResourceTable<Team, TeamColumn>;

    constructor(public tableService: ResourceTableService) {}
}
